export { SimilarDesigns } from './SimilarDesigns';
